export default {
    path: '/chatbot/:template_id/:workforce/:board/:url',
    name: 'chatbot-form',
    component: () => import('source/pages/concerns/BoardChatbotForm.vue'),
    meta: {
        title: 'Chatbot Form - HQZen',
        loginRequired: false,
    },
};
